import React from 'react'
import { Typography } from 'antd'
import { brand } from '../../theme/brand'
import { ListPage, SectionCard } from '../../theme/listkit'
import { MessagesSquare } from '../../components/icons'

const { Paragraph, Text } = Typography

const STREAM_APP_ID = '1632760'
const STREAM_DASHBOARD_URL = 'https://dashboard.getstream.io/'

export function StreamCommunityInfo() {
  return (
    <ListPage
      intro={{
        eyebrow: 'Community · Chats',
        description:
          'Chat and the Activity Feed are powered by GetStream. There is nothing to manage here — moderation lives in the Stream Dashboard.',
      }}
    >
      <SectionCard title="Community runs on GetStream" sub="Chat &amp; Activity Feed are hosted by GetStream">
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            marginBottom: 16,
          }}
        >
          <div
            style={{
              width: 44,
              height: 44,
              borderRadius: 12,
              background: 'rgba(30,78,140,.10)',
              border: '1px solid rgba(30,78,140,.25)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            <MessagesSquare size={22} color={brand.jaguar} />
          </div>
          <div style={{ fontFamily: brand.fSans, fontWeight: 600, fontSize: 13, color: brand.sub }}>
            App id <Text code>{STREAM_APP_ID}</Text>
          </div>
        </div>

        <Paragraph style={{ fontFamily: brand.fSans, fontSize: 13.5, color: brand.ink, lineHeight: 1.6 }}>
          Chat and the Activity Feed are now powered by GetStream. They are no longer
          stored in Supabase, so there are no Chat, Message, or Feed Item resources to
          manage here.
        </Paragraph>

        <Paragraph style={{ fontFamily: brand.fSans, fontSize: 13.5, color: brand.ink, lineHeight: 1.6 }}>
          Moderation is done in the Stream Dashboard (app id <Text code>{STREAM_APP_ID}</Text>).
          Open the dashboard and use the app&apos;s Chat &rarr; Moderation and Feeds sections
          to review and act on content.
        </Paragraph>

        <a
          href={STREAM_DASHBOARD_URL}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 8,
            marginTop: 6,
            padding: '10px 18px',
            borderRadius: 10,
            background: brand.navyGrad,
            border: '1px solid ' + brand.gold,
            color: brand.gold,
            fontFamily: brand.fSans,
            fontWeight: 700,
            fontSize: 13,
            letterSpacing: '.02em',
            textDecoration: 'none',
          }}
        >
          Open Stream Dashboard &rarr;
        </a>
      </SectionCard>
    </ListPage>
  )
}
